import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Form, Spinner } from "react-bootstrap";
import api from "./Api";

export default function QuestionDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const res = await api.get(`/pustak-questionbank/get/${id}`);
      if (res.data.status === "success") setData(res.data.data);
      setLoading(false);
    };
    load();
  }, [id]);

  const handleSave = async () => {
    const res = await api.post(`/pustak-questionbank/update/${id}`, {
      questionjson: data.questionjson,
    });
    alert(res.data.message);
  };

  const handleDelete = async () => {
    if (window.confirm("Delete this question set?")) {
      const res = await api.delete(`/pustak-questionbank/delete/${id}`);
      alert(res.data.message);
      navigate(-1);
    }
  };

  if (loading) return <Spinner animation="border" />;

  return (
    <div className="container mt-4">
      <h5>
        📘 {data.seriesname} - {data.bookname}
      </h5>
      <hr />
      <div>
        {data.questionjson?.map((q, i) => (
          <div key={i} className="mb-3 p-3 border rounded">
            <Form.Group>
              <Form.Label>Question {i + 1}</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={q.question}
                onChange={(e) => {
                  const newJson = [...data.questionjson];
                  newJson[i].question = e.target.value;
                  setData({ ...data, questionjson: newJson });
                }}
              />
            </Form.Group>
            <Button
              variant="danger"
              size="sm"
              className="mt-2"
              onClick={() => {
                const updated = data.questionjson.filter((_, x) => x !== i);
                setData({ ...data, questionjson: updated });
              }}
            >
              Delete
            </Button>
          </div>
        ))}
      </div>
      <Button variant="success" onClick={handleSave}>
        Save Changes
      </Button>{" "}
      <Button variant="secondary" onClick={() => navigate(-1)}>
        Back
      </Button>{" "}
      <Button variant="danger" onClick={handleDelete}>
        Delete Set
      </Button>
    </div>
  );
}
